<template>
  <div class="finish-container">
    <h2>Congratulations!</h2>
    <p>
      You have successfully completed your onboarding process. You are on your
      way to enjoying stable power supply!
      <br />
      <br />
      We are now processing your unit for installation and will call you soon to
      finalize the documentation and installation process. An email with your
      purchase details has been sent to you.
      <br />
      <br />
      <br />
      Thank you for choosing Arnergy!
    </p>
    <success-animation></success-animation>
  </div>
</template>

<script>
import SuccessAnimation from '../../../SuccessAnimation.vue'

export default {
  name: "LOFinish",
  props: ["updateStatus", "updateTracker"],
  components: {
    SuccessAnimation,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    this.updateTracker(true);
    this.updateStatus(6);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
}

.finish-container {
  p {
    color: #727272;
    font-size: 16px;
    line-height: 24px;
    margin: 30px auto;
    text-align: center;
  }

  h2 {
    color: #0892d0;
    margin-bottom: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/LOFinish.vue